import useRecordImage from '$tablet-app/src/app/images/hooks/useRecordImage';
import { recipe_thumbnail_image_edits } from '$tablet-app/src/app/recipes/data/image_params';
import { Recipe } from '$tablet-app/src/app/recipes/types';
import { spacing } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { Image } from 'react-native-elements/dist/image/Image';
import RecipeImagePlaceholder from '../RecipeImagePlaceholder';

interface RecipeImageProps {
  isSmallScreen?: boolean;
  imageWidth: number;
  recipe: Recipe;
}

const RecipeImage: FC<RecipeImageProps> = (props) => {
  const { isSmallScreen = false, imageWidth, recipe } = props;

  const { uri } = useRecordImage({
    record: recipe,
    edits: recipe_thumbnail_image_edits,
  });

  return (
    <View>
      {uri && !isSmallScreen ? (
        <Image style={styles.image} source={{ uri }} />
      ) : uri ? (
        <Image
          style={{
            width: imageWidth - spacing[3] * 2,
            height: (imageWidth * 8) / 9,
            borderRadius: 10,
          }}
          source={{ uri }}
        />
      ) : (
        <RecipeImagePlaceholder style={styles.image} />
      )}
    </View>
  );
};

// Styles
const styles = StyleSheet.create({
  image: {
    height: 80,
    width: 90,
    borderRadius: 10,
  },
});

export default RecipeImage;
